module.exports = __webpack_public_path__ + "img/NetzTalibanDetails.afd86276.png";